import {ColouredLabel} from '@management-ui/core';
import React from 'react';

export default function Status({entity}) {
  return entity.status ? <ColouredLabel label={entity.status.title} colour={entity.status.colour}/> : null;
}
